// import router from "@/router";

/**
 * @description getMessage extracts the message body from the response.
 * @param {*} response Http response
 */
const getMessage = response => {
  if (!response || !response.data) return 'Service Unavailable!';
  if (response.data && typeof response.data === 'string') return response.statusText;
  if (response.data) return response.data.message;
  return response || 'Connection Refused!';
};

/**
 * @description getStatusCode extracts the Http status code from the message body.
 * @param {*} response Http response
 */
const getStatusCode = response => {
  if (!response || !response.data) {
    // router.push('/login').catch(e => e);
    return 503;
  }
  if (response.status) return response.status;
  if (response.data) return response.data.status;
  return 200;
};

export { getMessage, getStatusCode };
